const themeColors = {
  black: "#000000",
  blackShadow: "rgba(0, 0, 0, 0.50)",
  red: "#FF0000",
  blue: "#0038FF",
  lightBlue: "#7E9AFD",
  betweenBlueGreed: "hsla(187, 97%, 29%, 1)",
  yellow: "#F9FE00",
  lightYellow: "#FDFFA4",
  gray: "#C0C0C0",
  grayBorder: "#989898",
  txtGray: "#616161",
  white: "#FFFFFF",
}

export { themeColors }
